import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Drawer } from 'components/Ui';
import { selectDrawerStatus } from 'containers/DrawerManager/selectors';
import { hideDrawer as hideDrawerRequest } from 'containers/DrawerManager/actions';
import { EDIT_EMAIL_ADDRESS } from './constants';
import EditEmailAddressForm from './EditEmailAddressForm';
import ProcessingModal from '../ProcessingModal';
import { closeRemoveEmailsDrawer } from '../actions';

const EditEmailAddressDrawer = ({ hideDrawer, isDrawerShown }) => {
  const dispatch = useDispatch();
  const handleHideDrawer = () => {
    dispatch(closeRemoveEmailsDrawer());
    hideDrawer(EDIT_EMAIL_ADDRESS);
  };

  return (
    <Drawer
      headerTitle="Account details"
      open={isDrawerShown}
      onClose={handleHideDrawer}
    >
      <EditEmailAddressForm onClose={() => hideDrawer(EDIT_EMAIL_ADDRESS)} />
      <ProcessingModal />
    </Drawer>
  );
};

EditEmailAddressDrawer.propTypes = {
  isDrawerShown: PropTypes.bool,
  hideDrawer: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  isDrawerShown: selectDrawerStatus(EDIT_EMAIL_ADDRESS),
});

const mapDispatchToProps = {
  hideDrawer: hideDrawerRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditEmailAddressDrawer);
